import Layout from '@/views/layout/Layout'
const unionRouter = {
    path: '/userCenter',
    name: 'userCenter',
    component: Layout,
    redirect: 'noRedirect',
    children: [
        // 联盟申请路由
        {
            path: 'logunionSystem',
            name: 'logunionSystem',
            meta: { name: '联盟申请'},
            component: () => import('@/views/userCenter/union/logunionSystem'),
        },
        // 联盟申请信息路由
        {
            path: 'logunionInfo',
            name: 'logunionInfo',
            meta: { name: '审批通过'},
            component: () => import('@/views/userCenter/union/logunionInfo'),
        },
        // 联盟申请支付路由
        {
            path: 'logunionPay',
            name: 'logunionPay',
            meta: { name: '联盟信息支付'},
            component: () => import('@/views/userCenter/union/logunionPay'),
        },
        // 联盟功能设置路由
        {
            path: 'logunionSet',
            name: 'logunionSet',
            meta: { name: '联盟信息管理'},
            component: () => import('@/views/userCenter/union/logunionSet'),
        },
        // 联盟订单列表路由
        {
            path: 'logorderUnion',
            name: 'logorderUnion',
            meta: { name: '联盟订单'},
            component: () => import('@/views/userCenter/union/logorderUnion'),
        },
        // 联盟供应产品发布路由
        {
            path: 'logunionSupplyAdd',
            name: 'logunionSupplyAdd',
            meta: { name: '联盟供应信息修改'},
            component: () => import('@/views/userCenter/union/logunionSupplyAdd'),
        },
        // 联盟供应产品列表路由
        {
            path: 'logunionSupplyList',
            name: 'logunionSupplyList',
            meta: { name: '联盟供应信息列表'},
            component: () => import('@/views/userCenter/union/logunionSupplyList'),
        },
    ]
}
export default unionRouter


// WEBPACK FOOTER //
// ./src/router/modules/union.js